module.exports = __webpack_public_path__ + "img/arrow-left-disabled.b5c29905.svg";